const application_json = 'application/json';
const url = process.env.REACT_APP_SERVER_URL_AUTH;

const send = (data) => {
  return fetch(`${url}`, {
    method: 'POST',
    headers: {
      Accept: application_json,
      'Content-Type': application_json,
      'x-from': 'Mutua-Ecosystem'
    },
    body: JSON.stringify(data)
  })
    .then((response) => response.json())
    .then((json) => json)
    .catch((error) => {
      console.error(error);
    });
};

export { send };
